export default "__VITE_ASSET__ca1891b2__"